module.exports = __webpack_public_path__ + "Roboto-Regular.eot";


//////////////////
// WEBPACK FOOTER
// ./~/materialize-css/fonts/roboto/Roboto-Regular.eot
// module id = 30
// module chunks = 0